// ==========================================
// AUTO-GENERATED FROM JAVA ENUM
// Source: Java FeatureKey
// DO NOT EDIT MANUALLY - Use sync-java-enums.js
// ==========================================

/**
 * FeatureKey enum synchronized from Java
 * Represents feature flags available in the system
 */
export enum FeatureKey {
  loc_map = 'loc_map',
  loc_locations = 'loc_locations',
  loc_journeys = 'loc_journeys',
  loc_journey_routing = 'loc_journey_routing',
  gps_to_address_resolution = 'gps_to_address_resolution',
  loc_beacon = 'loc_beacon',
  loc_geolayer = 'loc_geolayer',
  device_odometer = 'device_odometer',
  device_running_hours = 'device_running_hours',
  private_wifi_resolution = 'private_wifi_resolution',
  only_private_cellular_resolution = 'only_private_cellular_resolution',
  mobile_checkin = 'mobile_checkin',
  mobile_device_creation = 'mobile_device_creation',
  activity_db = 'activity_db',
  geozone_manager = 'geozone_manager',
  geozone_list = 'geozone_list',
  geozone_db = 'geozone_db',
  geozone_taglist = 'geozone_taglist',
  geozone_network = 'geozone_network',
  geozone_visit = 'geozone_visit',
  geozone_visit_report = 'geozone_visit_report',
  geozone_visit_ui = 'geozone_visit_ui',
  flow_definition = 'flow_definition',
  flow_report = 'flow_report',
  zendesk_ticket = 'zendesk_ticket',
  process_manager = 'process_manager',
  automation_manager = 'automation_manager',
  shock_event = 'shock_event',
  orientation_state = 'orientation_state',
  sensor_instantaneous = 'sensor_instantaneous',
  orientation_event = 'orientation_event',
  sensor_battery_low = 'sensor_battery_low',
  notification_manager = 'notification_manager',
  no_system_notifications = 'no_system_notifications',
  utilization_basic = 'utilization_basic',
  utilization_dashboards = 'utilization_dashboards',
  utilization_goals = 'utilization_goals',
  maintenance_basic = 'maintenance_basic',
  business_inject = 'business_inject',
  business_search = 'business_search',
  search_advanced = 'search_advanced',
  search_save = 'search_save',
  search_export = 'search_export',
  search_aggregate = 'search_aggregate',
  table_advanced_aggregations = 'table_advanced_aggregations',
  report_generator = 'report_generator',
  report_raw = 'report_raw',
  report_pt100 = 'report_pt100',
  report_orientation = 'report_orientation',
  report_external_sensors = 'report_external_sensors',
  alert_activelist = 'alert_activelist',
  alert_histlist = 'alert_histlist',
  alert_activedb = 'alert_activedb',
  alert_histdb = 'alert_histdb',
  alert_ruleconf = 'alert_ruleconf',
  alert_search = 'alert_search',
  alert_subject = 'alert_subject',
  alert_templates = 'alert_templates',
  alert_push = 'alert_push',
  alert_comment = 'alert_comment',
  alert_suppress = 'alert_suppress',
  alert_ack = 'alert_ack',
  alert_assign = 'alert_assign',
  asset_tag_alerts = 'asset_tag_alerts',
  user_profile = 'user_profile',
  customize_password = 'customize_password',
  landing_page = 'landing_page',
  allow_filter_landing_page = 'allow_filter_landing_page',
  conf_userview = 'conf_userview',
  conf_useredit = 'conf_useredit',
  virt_thirdparty = 'virt_thirdparty',
  conf_profileinfo = 'conf_profileinfo',
  subscription_self_renewal = 'subscription_self_renewal',
  subscription_self_replace = 'subscription_self_replace',
  subscription_self_create = 'subscription_self_create',
  subscription_self_extend = 'subscription_self_extend',
  subscription_tab = 'subscription_tab',
  activation_predefined = 'activation_predefined',
  bulk_operations = 'bulk_operations',
  mobile_bleconsole = 'mobile_bleconsole',
  mobile_bleconsole_advanced_commands = 'mobile_bleconsole_advanced_commands',
  subscription_metrics = 'subscription_metrics',
  partner_org_manage = 'partner_org_manage',
  int_api_partner_org = 'int_api_partner_org',
  impersonate = 'impersonate',
  partner_plan_management = 'partner_plan_management',
  partner_initial_plan = 'partner_initial_plan',
  manage_api_only_plan = 'manage_api_only_plan',
  diagnostic_tab = 'diagnostic_tab',
  data_access_domain = 'data_access_domain',
  data_access_diagnostics = 'data_access_diagnostics',
  data_access_failure = 'data_access_failure',
  diagnostic_organisation = 'diagnostic_organisation',
  diagnostic_run_period = 'diagnostic_run_period',
  int_messages = 'int_messages',
  usage_profile = 'usage_profile',
  int_rest_mqtt_push = 'int_rest_mqtt_push',
  int_api_thirdparty = 'int_api_thirdparty',
  int_api_geozone = 'int_api_geozone',
  int_api_geobeacon = 'int_api_geobeacon',
  int_api_alert = 'int_api_alert',
  int_api_inject = 'int_api_inject',
  int_api_device_usage_profile = 'int_api_device_usage_profile',
  int_api_bulk_update = 'int_api_bulk_update',
  int_api_seq_nbrs = 'int_api_seq_nbrs',
  int_api_bulk_history_delete = 'int_api_bulk_history_delete',
  int_api_activation = 'int_api_activation',
  int_api_clientapp = 'int_api_clientapp',
  int_api_subscription_renew = 'int_api_subscription_renew',
  int_api_subscription_create_from_prefined = 'int_api_subscription_create_from_prefined',
  int_api_subscription_auto_renew = 'int_api_subscription_auto_renew',
  int_api_subscription_products = 'int_api_subscription_products',
  int_api_report_custom_upload = 'int_api_report_custom_upload',
  int_api_battery_replace = 'int_api_battery_replace',
  int_api_advanced_routing = 'int_api_advanced_routing',
  int_api_device_push_data = 'int_api_device_push_data',
  int_simulator = 'int_simulator',
  int_api_force_update_fw = 'int_api_force_update_fw',
  int_api_manufacturing = 'int_api_manufacturing',
  int_api_copy_from_prod = 'int_api_copy_from_prod',
  int_api_user = 'int_api_user',
  int_api_audit_log = 'int_api_audit_log',
  int_api_auto_create_external_devices = 'int_api_auto_create_external_devices',
  auto_create_unknown_tag_by_mac = 'auto_create_unknown_tag_by_mac',
  auto_delete_auto_created_device_by_mac = 'auto_delete_auto_created_device_by_mac',
  int_sso = 'int_sso',
  visibility_filters = 'visibility_filters',
  organisation_visibility_filters = 'organisation_visibility_filters',
  custom_interface = 'custom_interface',
  utilization_suez = 'utilization_suez',
  dashboard = 'dashboard',
  dashboard_mobile = 'dashboard_mobile',
  whitelabel_identifiers = 'whitelabel_identifiers',
  int_sensize = 'int_sensize',
  custom_i18n_message = 'custom_i18n_message',
  audit_log = 'audit_log',
  firmware_management = 'firmware_management',
  firmware_management_non_preferred = 'firmware_management_non_preferred',
  location_history = 'location_history',
  show_invoicing = 'show_invoicing',
  invoice_billed_entity = 'invoice_billed_entity',
  factory_upload = 'factory_upload',
  demo_environment = 'demo_environment',
  delete_timeseries = 'delete_timeseries',
  delete_location = 'delete_location',
  legal_document = 'legal_document',
  image_library = 'image_library',
  metar_weather_location = 'metar_weather_location',
  never_auto_disable_report_schedule = 'never_auto_disable_report_schedule',
  integrated_help = 'integrated_help',
  disable_profile_image = 'disable_profile_image',
  mcp_connector = 'mcp_connector',
  ai_chat = 'ai_chat',
  ai_summaries = 'ai_summaries',
  use_harvested_cell_towers = 'use_harvested_cell_towers'
}

/**
 * Type helper for FeatureKey values
 */
export type FeatureKeyValue = `${FeatureKey}`;

/**
 * Get all FeatureKey values as array
 */
export const getFeatureKeyValues = (): FeatureKey[] => {
  return Object.values(FeatureKey);
};

/**
 * Check if value is valid FeatureKey
 */
export const isValidFeatureKey = (value: unknown): value is FeatureKey => {
  return typeof value === 'string' && Object.values(FeatureKey).includes(value as FeatureKey);
};
